import React, { useContext } from "react";
import { Flex, Heading, Text, Spinner } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { featureRoutes } from "../constants/featureCostants";

// Reached either as FeatureRoute's last-resort fallback, or by a direct
// URL/bookmark/browser-history hit. Either way, always re-check the user's
// CURRENT features first and bounce to the first one they actually have -
// only show the dead-end message when they truly have zero features.
const NoAccess = () => {
    const { features, featuresLoading } = useContext(AuthContext);

    if (featuresLoading) {
        return (
            <Flex justify="center" align="center" minH="100vh">
                <Spinner size="xl" color="brand.700" />
            </Flex>
        );
    }

    const fallback = featureRoutes.find((route) => features.includes(route.id));
    if (fallback) {
        return <Navigate to={fallback.link} replace />;
    }

    return (
        <Flex direction="column" justify="center" align="center" minH="100vh" textAlign="center" px={4}>
            <Heading size="lg" color="brand.700" mb={2}>
                Nemate pristup
            </Heading>
            <Text color="gray.600">
                Za ovu lokaciju nije omogućena nijedna značajka. Obratite se administratoru.
            </Text>
        </Flex>
    );
};

export default NoAccess;
